<script setup lang="ts">
  import LoginView from '@/views/LoginView.vue';
  import { computed, onMounted, ref } from 'vue';
  import { getSession } from '@/indexedDB';
  import { DB } from '@/types';

  const db = ref<DB | null>(null);
  const isAuthApp = computed(() => !!(db.value && db.value?.token));

  onMounted(async () => {
    db.value = await getSession('user');
  });
</script>

<template>
  <div v-if="isAuthApp">
    <slot name="body"></slot>
  </div>
  <div v-else>
    <LoginView />
  </div>
</template>

<style scoped></style>
